<template>
  <div class="conPay">
    <div class="mainArea">
      <div class="title">扫码支付</div>
      <div class="payCode">
        <t-qrcode
          v-if="payUrl"
          :value="payUrl"
          :icon="require('@/assets/images/boluoCen.png')"
          borderless
          bgColor="#f7f7f7"
          :size="240"
          :iconSize="56"
          class="qrPos"
        />
        <svg-icon
          icon-class="close"
          class="close"
          @click="closeDialog"
        ></svg-icon>
      </div>
      <div class="useWx">
        使用 <svg-icon icon-class="wx" class="wxCode" /> 微信扫码支付
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import {
  getLessionsDetail,
  getAudiobookDetail,
  createOrder,
  wechatAppletPay,
  getOrderDetail
} from "@/api/publicApi";

export default {
  props: {
    payType: {
      type: Number,
      default: 0
    },
    lessionOrAudioBookId: {
      type: Number,
      default: 0
    }
  },
  components: {},

  data() {
    return {
      isQRCodeGenerated: false,
      payUrl: "", // 用于存储支付链接
      orderNo: "", // 订单号
      orderInfoTimer: null, // 添加定时器引用
      lastTimer: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(["closePayDialog", "refreshBasicInfo"]),

    closeDialog() {
      this.closePayDialog();
      clearInterval(this.orderInfoTimer);
      this.orderInfoTimer = null;
    },

    generateQRCode(payUrl) {
      this.payUrl = payUrl;
      // console.log("生成二维码:", payUrl);
    },

    initData() {
      // type: 0, //type - 资源类型 (1=有声书, 2=课程)
      let type = this.payType;
      let id = this.lessionOrAudioBookId;

      if (type == 2) {
        getLessionsDetail({
          id: id
        }).then(res => {
          if (!res.code) {
            this.info = res.data.lession;

            const data = {
              goodsId: this.info.id,
              goodsNo: this.info.goodsNo,
              goodsName: this.info.title,
              orderAmount: this.info.price,
              goodsType: 6
            };

            this.createOrderInfo(data);
          } else {
            // this.$message.warning("未获取课程信息，返回首页");
            // this.$router.push("/");
          }
        });
      } else if (type == 1) {
        getAudiobookDetail({
          id: id
        }).then(res => {
          if (!res.code) {
            this.info = res.data.audiobook;

            const data = {
              goodsId: this.info.id,
              goodsNo: this.info.goodsNo,
              goodsName: this.info.title,
              orderAmount: this.info.price,
              goodsType: 5
            };

            this.createOrderInfo(data);
          } else {
            // this.$message.warning("未获取有声书信息，返回首页");
            // this.$router.push("/");
          }
        });
      }
    },

    createOrderInfo(data) {
      createOrder({
        goodsId: data.goodsId,
        goodsNo: data.goodsNo,
        goodsName: data.goodsName,
        orderAmount: data.orderAmount,
        goodsType: data.goodsType
      }).then(res => {
        if (!res.code) {
          this.orderNo = res.data.orderNo;
          this.wechatPay(this.orderNo);
        } else {
          // this.$message.error(res.msg);
        }
      });
    },

    // 微信支付
    wechatPay(orderNo) {
      wechatAppletPay({
        orderNo: orderNo
      }).then(res => {
        if (!res.code) {
          // console.log("微信支付：", res.data);
          this.payUrl = res.data.payUrl;
          this.runOrder();
        } else {
          // this.$message.error(res.msg);
        }
      });
    },

    // 轮询订单支付结果
    runOrder() {
      this.lastTimer = new Date().getTime();
      this.getOrderInfo();
      if (!this.orderInfoTimer) {
        this.orderInfoTimer = setInterval(() => {
          this.getOrderInfo();
        }, 3000);
      }
    },

    getOrderInfo() {
      // OrderStatus_OrderStatusDefault   OrderStatus = 0 // 默认
      // OrderStatus_OrderStatusCreate    OrderStatus = 1 // 已下订单
      // OrderStatus_OrderStatusCancel    OrderStatus = 2 // 订单取消
      // OrderStatus_OrderStatusTimeout   OrderStatus = 3 // 订单超时关闭
      // OrderStatus_OrderStatusPartial   OrderStatus = 4 // 部分支付
      // OrderStatus_OrderStatusCompleted OrderStatus = 5 // 支付完成

      // PayStatus_PayStatusDefault       PayStatus = 0 // 默认
      // PayStatus_PayStatusWaitPay       PayStatus = 1 // 等待支付
      // PayStatus_PayStatusSuccess       PayStatus = 2 // 支付成功
      // PayStatus_PayStatusFail          PayStatus = 3 // 支付失败
      // PayStatus_PayStatusExpire        PayStatus = 4 // 过期
      // PayStatus_PayStatusRefunding     PayStatus = 5 // 退款中
      // PayStatus_PayStatusRefundSuccess PayStatus = 6 // 退款成功
      // PayStatus_PayStatusRefundFail    PayStatus = 7 // 退款失败
      // PayStatus_PayStatusNoNeedPay     PayStatus = 8 //无需支付

      if (!this.orderNo) return;
      getOrderDetail({
        orderNo: this.orderNo
      }).then(res => {
        if (!res.code) {
          // console.log("getOrderDetail: ", res);
          let curTimer = new Date().getTime();
          let timerDiff = Math.floor((curTimer - this.lastTimer) / 1000); //单位秒
          if (
            res.data.info.payStatus == "PayStatusSuccess" &&
            res.data.info.orderStatus == "OrderStatusCompleted"
          ) {
            clearInterval(this.orderInfoTimer);
            this.orderInfoTimer = null;
            this.refreshBasicInfo(); //更新详情及列表锁定状态
            this.$message.success("支付成功");

            this.closePayDialog();
          } else if (timerDiff > 300) {
            // 弹窗展示超5分钟后，关闭支付弹窗
            clearInterval(this.orderInfoTimer);
            this.orderInfoTimer = null;
            this.lastTimer = 0;
            this.$message.warning("订单超时，请重新点击购买");

            this.closePayDialog();
          }
        } else {
          // this.$message.warning("订单详情获取失败");
          // this.$router.push("/");
        }
      });
    }
  },
  created() {},
  mounted() {
    document.body.style.overflow = "hidden";

    this.initData();
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.conPay {
  position: fixed;
  top: 0;
  height: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  .mainArea {
    width: 334px;
    height: 385px;
    border-radius: 16px;
    background: #f7f7f7;

    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin-top: 42px;
      color: #262626;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
    }

    .payCode {
      width: 240px;
      height: 240px;
      margin-top: 9px;

      // box-sizing: border-box;
      // border: 1px solid #ae3510;

      position: relative;
      // overflow: hidden;

      .qrPos {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .close {
        cursor: pointer;
        width: 24px;
        height: 24px;

        position: absolute;
        top: -68px;
        right: -33px;
      }
    }

    .useWx {
      color: #4d4d4d;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      margin-top: 17px;

      display: flex;
      align-items: center;
      justify-content: center;
      .wxCode {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
